import React, { Component } from "react";
import { Button } from "@mui/material";

import "./index.scss";

class ConfirmDialog extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { description, heading } = this.props;
        const buttons = this.props.buttons || [];

        return (
            <div className="show">
                <div className="popup-container-bg"></div>

                <div className="popup-container confirmation-popup">

                    <div className="popup-body">
                        { heading ?
                            <div className="popup-heading margin-top-2x">
                                { heading }
                            </div>
                            : null
                        }
                        { description ?
                            <div className="margin-top-1-4 popup-description">
                                { description }
                            </div>
                            : null
                        }
                        {buttons.length > 0 ? 
                            <div className="row margin-top-3x action-buttons action-buttons-responsive">
                                <Button
                                    onClick={buttons[0].onClick}
                                    variant={ buttons[0].variant || "outlined"}>
                                    { buttons[0].label }
                                </Button>

                                {buttons.length > 1 ? 
                                    <Button
                                        onClick={buttons[1].onClick}
                                        variant={buttons[1].variant || "contained"}>
                                        { buttons[1].label }
                                    </Button>:null
                                }
                            </div> : null
                        }
                        
                    </div>
                </div>
            </div>
        );

    }
}

export default ConfirmDialog;